import { Component, Input, SimpleChanges, OnChanges, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-dt-shop-sales-by-department',
  templateUrl: './dt-shop-sales-by-department.component.html',
  styleUrls: ['./dt-shop-sales-by-department.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class DtShopSalesByDepartmentComponent {
  @Input() dashboardData: any;
 
   @ViewChild('dtShopTimeWiseSalesChart', { static: false }) chartRef!: ElementRef<HTMLCanvasElement>;
   chart: Chart | null = null;
 
   ngAfterViewInit() {
     this.renderChart();
   }
 
   ngOnChanges(changes: SimpleChanges) {
     if (changes['dashboardData']) {
       this.renderChart();
     }
   }
 
   renderChart() {
     if (!this.dashboardData || !this.chartRef) return;

     // Use shop-wise sales data for Graph 2
     let dashboardDtShopsSales = this.dashboardData.dashboardDtShopsSales || [];
     if (typeof dashboardDtShopsSales === 'string') {
       dashboardDtShopsSales = JSON.parse(dashboardDtShopsSales);
     }

     const shopNames = dashboardDtShopsSales.map((item: any) => item.shop_name);
     const sushiSales = dashboardDtShopsSales.map((item: any) => parseFloat(item.total_sushi));
     const bentoSales = dashboardDtShopsSales.map((item: any) => parseFloat(item.total_bento));
     const commonSales = dashboardDtShopsSales.map((item: any) => parseFloat(item.total_common));

     if (this.chart) {
       this.chart.destroy();
     }

     this.chart = new Chart(this.chartRef.nativeElement.getContext('2d')!, {
       type: 'bar',
       data: {
         labels: shopNames,
         datasets: [
           { label: 'Sushi', data: sushiSales, backgroundColor: 'rgb(230, 219, 12)' },
           { label: 'Bento', data: bentoSales, backgroundColor: '#cc6d19' },
           { label: 'Common', data: commonSales, backgroundColor: 'rgba(54,162,235,0.7)' }
         ]
       },
       options: {
         responsive: true,
         plugins: {
           legend: {
             display: true,
             labels: { font: { size: 14 } }
           }
         },
         scales: {
           x: {
             stacked: true,
            //  barPercentage: 0.4,
            //  categoryPercentage: 0.5,
             ticks: {
               font: { size: 14 },
               maxRotation: 45,
               minRotation: 0,
               autoSkip: false
             }
           },
           y: {
             stacked: true,
             beginAtZero: true,
             ticks: {
               font: { size: 14 },
               callback: function(value:any) { return '$' + value; }
             }
           }
         },
         datasets: {
           bar: { barThickness: 50 }
         }
       }
     });
   }
 
   formatLabel(r: any): string {
     const fromTime = this.formatTime12(r.time_from);
     const toTime = this.formatTime12(r.time_to);
     if (r.time_slot.includes('breakfast')) return `Breakfast (${fromTime} - ${toTime})`;
     if (r.time_slot.includes('lunch')) return `Lunch (${fromTime} - ${toTime})`;
     if (r.time_slot.includes('tea')) return `Tea Time (${fromTime} - ${toTime})`;
     if (r.time_slot.includes('dinner')) return `Dinner (${fromTime} - ${toTime})`;
     return `${r.time_slot} (${fromTime} - ${toTime})`;
   }
 
   formatTime12(timeStr: string): string {
     if (!timeStr) return '';
     const [h] = timeStr.split(':');
     let hour = parseInt(h, 10);
     const ampm = hour >= 12 ? 'PM' : 'AM';
     hour = hour % 12 || 12;
     return `${hour}${ampm}`;
   }
}
